<ion-app [class.dark-theme]="dark">
  <ngx-loading-bar [color]="'#428cff'" />
  <ion-split-pane contentId="main-content" *transloco="let t">

    <ion-menu contentId="main-content">
      <ion-content>
        <ion-list lines="none">
          <ion-list-header>
            {{ t('app') }}
          </ion-list-header>
          @for (p of appPages; track p; let i = $index) {
          <ion-menu-toggle autoHide="false">
            <ion-item [routerLink]="p.url" routerLinkActive="selected" routerDirection="root" detail="false">
              <ion-icon slot="start" [name]="p.icon" />
              <ion-label>
                {{ t(p.title) }}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
          }
        </ion-list>

        <ion-list lines="none">
          <ion-list-header>
            Konto
          </ion-list-header>

          <ion-item>
            <ion-icon slot="start" name="person-outline" />
            <ion-label>
              {{ userName }}
            </ion-label>
          </ion-item>

          <ion-menu-toggle autoHide="false">
            <ion-item button (click)="logout()" detail="false">
              <ion-icon slot="start" name="log-out-outline" />
              <ion-label>
                Abmelden
              </ion-label>
            </ion-item>
          </ion-menu-toggle>

          <ion-menu-toggle autoHide="false">
            <ion-item>
              <ion-icon slot="start" name="moon-outline" />
              <ion-toggle [checked]="dark" (ionChange)="setDark($event.target.checked)" aria-label="Toggle Theme">
                Dark Mode
              </ion-toggle>
            </ion-item>
          </ion-menu-toggle>

        </ion-list>

        <ion-list lines="none">
          <ion-list-header>
            Info
          </ion-list-header>
          <ion-item>
            <ion-label>
              <small>{{ t('version', { version: version }) }}</small>
            </ion-label>
          </ion-item>
          <ion-item>
            <ion-label>
              <small>Refreshed: {{ resumed | date : 'HH:mm' }}</small>
            </ion-label>
            @if (hourCount > 0) {
            <ion-label>
              <small>Need Sync: {{hourCount}}</small>
            </ion-label>
            }
          </ion-item>
          <ion-item>
            <a href="https://www.viag.ch" target="_blank">
              <img src="./assets/img/viag-logo.png" alt="viag Müller Informatik" />
            </a>
          </ion-item>
          <ion-item>
            <ion-label>
              <span class="copyright">© viag Müller Informatik 2019-{{currentYear}}</span>
            </ion-label>
          </ion-item>
        </ion-list>
      </ion-content>
    </ion-menu>

    <ion-router-outlet id="main-content" />

  </ion-split-pane>

</ion-app>